// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Package24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Package24Filled: FC<Package24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M11 21.725v-9.15L3 7.95v8.025A1.948 1.948 0 0 0 4 17.7l7 4.025Zm2 0 7-4.025a1.948 1.948 0 0 0 1-1.725V7.95l-8 4.625v9.15Zm3.975-13.75 2.95-1.725L13 2.275A1.966 1.966 0 0 0 12 2c-.35 0-.683.092-1 .275L9.025 3.4l7.95 4.575ZM12 10.85l2.975-1.7-7.925-4.6-3 1.725L12 10.85Z" />
        </svg>
    );
};

export default Package24Filled;
